import { baseNextjsUrl } from "@memorang/constants/src/urls";

export const faqsEndpoint = `${baseNextjsUrl}/api/ai/app-faqs`;

export const dialogTexts = {
	faqs: {
		title: "dialog.faqs.title",
		body: "dialog.faqs.body",
	},
};
